<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Text -->
    <claim-text-field
      v-model="$attrs.claim.text"
      :error="$attrs.errors.claim.text"
    />

    <!-- Datetime -->
    <date-time-field
      v-model="$attrs.claim.datetime"
      :error="$attrs.errors.claim.datetime"
    />

    <!-- Client -->
    <client-field
      v-model="$attrs.claim.client"
      :error="$attrs.errors.claim.client"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import claimTextField from '@/components/forms/claim/fields/ClaimText'
import dateTimeField from '@/components/forms/claim/fields/DateTime'
import clientField from '@/components/forms/claim/fields/Client'

export default {
  name: 'claim-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    claimTextField,
    dateTimeField,
    clientField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClaimBlankForm.vue?57451699